import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
export function Home() {
  return <div className="min-h-screen bg-white font-sans" data-id="element-44">
      <Header data-id="element-45" />
      <main data-id="element-46">
        <Hero data-id="element-47" />
        <HowItWorks data-id="element-48" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-slate-900 text-slate-400 py-12 px-6 border-t border-slate-800" data-id="element-49">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-50">
          <div className="flex items-center gap-2" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/pVqK3fgaWQMkP5ESHZaQdg/127905.png" alt="Qlyns Capital" className="h-8 w-auto brightness-0 invert opacity-80" data-id="element-52" />
          </div>
          <p className="text-sm" data-id="element-53">
            © {new Date().getFullYear()} Qlyns Capital. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}